module.exports = __webpack_public_path__ + "img/phoneMoc2.431d352f.png";